import { ContactWindow } from "@/components/contacts/ContactWindow";
import { contactsFilterCategory } from "@/data/filters/categories/contacts";
import type { Configuration } from "@/types/campaign";
import { createFileRoute } from "@tanstack/react-router";
import { type SetStateAction } from "jotai";
import { useCallback, useMemo } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/define/$category/contacts",
)({
  component: RouteComponent,
  loader: () => ({
    crumb: contactsFilterCategory.title,
  }),
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { useEditCampaign } = Route.useRouteContext();
  const { editCampaign, setEditCampaign } = useEditCampaign();

  const configuration = useMemo(
    () => editCampaign.configurations.find((c) => c.quality === 1),
    [editCampaign.configurations],
  );

  const setConfiguration = useCallback(
    (value: SetStateAction<Configuration>) => {
      setEditCampaign((prev) => ({
        ...prev,
        configurations: prev.configurations.map((c) =>
          c.quality === 1
            ? typeof value === "function"
              ? value(c)
              : value
            : c,
        ),
      }));
    },
    [setEditCampaign],
  );

  if (!configuration) {
    navigate({ to: "/campaigns/$id/define" });
    return;
  }

  return (
    <ContactWindow
      configuration={configuration}
      setConfiguration={setConfiguration}
      onDoneUpdating={() => navigate({ to: "/campaigns/$id/define" })}
    />
  );
}
